import "./Content.css";
//SVGS
import discordIcon from "../../SVGS/discord.svg";
import githubIcon from "../../SVGS/github.svg";
import linkedinIcon from "../../SVGS/linkedin-original.svg";
import steamIcon from "../../SVGS/steam.svg";
import cssIcon from "../../SVGS/css-3.svg";
import cSharpIcon from "../../SVGS/c-sharp-c.svg";
import pythonIcon from "../../SVGS/python.svg";
import typescriptIcon from "../../SVGS/typescript-icon.svg";
import sqlIcon from "../../SVGS/sql-database-sql-azure.svg";
import javaIcon from "../../SVGS/java.svg";
import javascriptIcon from "../../SVGS/javascript-js.svg";
import htmlIcon from "../../SVGS/html-5.svg";
import goldenControllerIcon from "../../SVGS/goldcontroller.svg";
import diplomaIcon from "../../SVGS/diploma2.svg";
import trophyIcon from "../../SVGS/trophy.svg";

import awsIcon from "../../SVGS/aws.svg";
import azureIcon from "../../SVGS/microsoft-azure.svg";
import reactIcon from "../../SVGS/react.svg";
import graphqlIcon from "../../SVGS/graphql.svg";
import vsIcon from "../../SVGS/visual-studio.svg";
import xcodeIcon from "../../SVGS/xcode1.svg";
import cloudflareIcon from "../../SVGS/cloudflare1.svg";
import openAIIcon from "../../SVGS/openai1.svg";
import unrealIcon from "../../SVGS/unreal1.svg";
import unityIcon from "../../SVGS/unity3d.svg";
//Images
import SaysoIcon from "../../Images/saysoIcon.jpg";
import CyborgIcon from "../../Images/cyborgmobileIcon.jpg";
import DigipenIcon from "../../Images/digipenIcon.jpg";
import MicrosoftIcon from "../../Images/microsoftIcon.jpg";
import ClutchIcon from "../../Images/2B_Logo.jpg";
//Components
import WorkexprienceItem from "./WorkexperienceItem";
import SkillsItem from "./SkillsItem";

function Content() {
  const ExperienceItems = [
    {
      Icon: SaysoIcon,
      CompanyName: "Software Engineer at Sayso, LLC",
      Date: "June 2023 - Present",
      Location: "Seattle, Washington, United States - Remote",
      Points: [
        `Configured front-end hosting through Cloudflare for efficient and reliable deployment of the website.`,

        `Set up a database using GraphQL to manage and query application data effectively.`,

        `Designed and implemented encrypted messaging to ensure secure communication.`,

        `Performed major React state management to maintain seamless functionality and enhance user interactions.`,

        `Designed and developed responsive web layouts with React, providing an engaging and adaptable user experience.`,
      ],
    },
    {
      Icon: MicrosoftIcon,
      CompanyName: "Software Engineer Intern at Microsoft",
      Date: "June 2024 - September 2024",
      Location: "Redmond, Washington, United States - Onsite",
      Points: [
        `Designed and implemented a new feature for Microsoft’s
          on-call incident system using OpenAI and Jupyter Notebook,
          reducing resolution time for on-call engineers.`,

        `Led the feature from concept through design, development,
          testing, and production deployment.`,

        `Gained valuable skills in OpenAI and Python while deepening
          my understanding of agile methodologies in AI development.`,
      ],
    },
    {
      Icon: MicrosoftIcon,
      CompanyName: "Software Engineer Intern at Microsoft",
      Date: "May 2023 - August 2023",
      Location: "Redmond, Washington, United States - Onsite",
      Points: [
        `Developed and deployed key functionalities within Azure Active Directory, guiding them through
rigorous testing phases and ultimately releasing them to millions of users.`,

        `Collaborated closely with stakeholders to meet strict deadlines, ensuring timely implementation
of updates.`,

        `Led the full lifecycle of a feature from design through delivery.`,

        `Fostered connections with key Microsoft figures and spearheaded an all-hands meeting attended
by hundreds.`,
      ],
    },
    {
      Icon: MicrosoftIcon,
      CompanyName: "New Technologist Intern at Microsoft",
      Date: "May 2022 - August 2022",
      Location: "Redmond, Washington, United States - Remote",
      Points: [
        `Developed an application to streamline resource access for students, taking on a leadership role to
guide the project.`,

        `Led the team in implementing key React concepts, including hooks, state management, props, and
context.`,

        `Integrated language localization to support a diverse student body.`,

        `Gained experience in app development, including design sprints, agile methodologies, and product
planning.`,
      ],
    },
    {
      Icon: CyborgIcon,
      CompanyName: "Jr. Software Engineer at Cyborg Mobile",
      Date: "November 2020 - May 2022",
      Location: "Renton, Washington, United States - Remote",
      Points: [
        `Developed landing pages for Digital Training Solution, an interactive online learning platform
aimed at fostering workplace inclusion.`,

        `Collaborated with a team to revitalize and modernize the Cyborg Mobile homepage.`,

        `Ensured code quality and stability through comprehensive testing with Jest.`,
      ],
    },
    {
      Icon: DigipenIcon,
      CompanyName: "Game 100 Summer Teacher at DigiPen",
      Date: "June 2016 - September 2016",
      Location: "Redmond, Washington, United States - Remote",
      Points: [
        `Mentored students in coursework for C++ and C#, providing guidance to ensure successful project
and game completion within deadlines.`,

        `Collaborated with the instructor to facilitate the class and support student learning.`,
      ],
    },
  ];

  const ProgrammingSkillsItems = [
    {
      Icon: javaIcon,
      Name: "Java",
      XP: "40%",
    },
    {
      Icon: javascriptIcon,
      Name: "Javascript",
      XP: "95%",
    },
    {
      Icon: cSharpIcon,
      Name: "C#",
      XP: "85%",
    },
    {
      Icon: sqlIcon,
      Name: "SQL",
      XP: "35%",
    },
    {
      Icon: htmlIcon,
      Name: "HTML",
      XP: "60%",
    },
    {
      Icon: cssIcon,
      Name: "CSS",
      XP: "60%",
    },
    {
      Icon: typescriptIcon,
      Name: "Typescript",
      XP: "95%",
    },
    {
      Icon: pythonIcon,
      Name: "Python",
      XP: "25%",
    },
  ];

  const ToolSkillsItems = [
    {
      Icon: vsIcon,
      Name: "Visual Studio",
      XP: "80%",
    },
    {
      Icon: xcodeIcon,
      Name: "Xcode",
      XP: "65%",
    },
    {
      Icon: unrealIcon,
      Name: "Unreal Engine",
      XP: "35%",
    },
    {
      Icon: unityIcon,
      Name: "Unity",
      XP: "50%",
    },
    {
      Icon: graphqlIcon,
      Name: "GraphQL",
      XP: "90%",
    },
    {
      Icon: openAIIcon,
      Name: "OpenAI",
      XP: "80%",
    },
    {
      Icon: reactIcon,
      Name: "React",
      XP: "100%",
    },
    {
      Icon: cloudflareIcon,
      Name: "Cloudflare",
      XP: "70%",
    },
    {
      Icon: awsIcon,
      Name: "AWS",
      XP: "83%",
    },
    {
      Icon: azureIcon,
      Name: "Azure",
      XP: "90%",
    },
  ];

  return (
    <div className="Content">
      <div className="Content-Inner">
        <div className="Left-Col">
          <div className="Content-Block">
            <div className="Content-Block-Header">Experience</div>
            <div className="Content-Block-Body">
              {ExperienceItems.map((item, key) => (
                <WorkexprienceItem
                  Icon={item.Icon}
                  CompanyName={item.CompanyName}
                  Date={item.Date}
                  Location={item.Location}
                  Points={item.Points}
                />
              ))}
            </div>
          </div>

          <div className="Content-Block">
            <div className="Content-Block-Header">Skills</div>
            <div className="Content-Block-Body">
              <div className="Skills-Container">
                <div className="Skills-Container-Title">
                  Programming Languages
                </div>
                <div className="Skills-List">
                  {ProgrammingSkillsItems.map((item, key) => (
                    <SkillsItem
                      Icon={item.Icon}
                      Name={item.Name}
                      XP={item.XP}
                    />
                  ))}
                </div>

                <div className="Skills-Container-Title">Software & Tools</div>
                <div className="Skills-List">
                  {ToolSkillsItems.map((item, key) => (
                    <SkillsItem
                      Icon={item.Icon}
                      Name={item.Name}
                      XP={item.XP}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="Content-Block">
            <div className="Content-Block-Header">Projects</div>
            <div className="Content-Block-Body">
              <div className="Workexperience-Item">
                <div className="Workexperience-Item-Header">
                  <img
                    className="Workexperience-Item-Icon"
                    src={SaysoIcon}
                    alt=""
                  />
                  <div className="Workexperience-Item-Info">
                    <span className="Workexperience-Item-Info-Company">
                      Sayso
                    </span>
                    <span className="Workexperience-Item-Info-Date">2023</span>
                    <span className="Workexperience-Item-Info-Location">
                      Currently In Development
                    </span>
                  </div>
                </div>
                <div className="Project-Item-Body">
                  This React-based platform is a unique blend of social media
                  and content aggregation, designed to be a more interactive
                  alternative to Twitter and an enhanced, visual version of
                  Linktree. Users can import videos, images, and posts from
                  TikTok, YouTube, Twitch, and Instagram, creating a curated
                  profile that displays content in an engaging, personalized
                  way. With features like custom emotes and creative profile
                  customization, it encourages cross-platform following by
                  allowing users to showcase their media rather than just
                  listing links. Just as LinkedIn revolutionized resumes, this
                  platform elevates your content portfolio.
                </div>
              </div>

              <div className="Workexperience-Item">
                <div className="Workexperience-Item-Header">
                  <img
                    className="Workexperience-Item-Icon Clutch-Icon"
                    src={ClutchIcon}
                    alt=""
                  />
                  <div className="Workexperience-Item-Info">
                    <span className="Workexperience-Item-Info-Company">
                      Clutch
                    </span>
                    <span className="Workexperience-Item-Info-Date">2020</span>
                    <span className="Workexperience-Item-Info-Location">
                      Finshed Prototype
                    </span>
                  </div>
                </div>
                <div className="Project-Item-Body">
                  This application, developed using React and Electron, brought
                  together key gaming functionalities, including streaming,
                  voice chat servers, a games store, and OBS integration for
                  seamless broadcasting to streaming platforms. It featured a
                  streamlined pipeline connecting all components, enabling users
                  to start streaming any game with a single click, hassle-free.
                  The project was a collaborative effort with friends,
                  undertaken to explore the development process while creating
                  something enjoyable and innovative.
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="Right-Col">
          <div className="Right-Col-Header">Currently LFW</div>

          <div className="Right-Col-Badges">
            <span className="Badge-Label">Programming Languages</span>
            &nbsp;
            <span className="Badge-Count">8</span>
          </div>
          <div className="Badge-Preview">
            <img src={cSharpIcon} className="Badge" alt="" />

            <img src={typescriptIcon} className="Badge" alt="" />

            <img src={sqlIcon} className="Badge" alt="" />

            <img src={pythonIcon} className="Badge" alt="" />
          </div>

          <div className="Right-Col-Badges">
            <span className="Badge-Label">References</span>
            &nbsp;
            <span className="Badge-Count">3</span>
          </div>

          <div className="Reference-Preview">
            <a
              href="https://www.linkedin.com/in/rashadjaraysa/"
              target="_blank"
              rel="noreferrer"
              className="Reference-Block"
            >
              <div className="Reference-Company-Icon">
                <img src={MicrosoftIcon} alt="" />
              </div>
              <div className="Reference-Preview-Name">Rashad Jaraysa</div>
              <span>Software Engineer @ Microsoft</span>
            </a>
            <a
              href="https://www.linkedin.com/in/cs-cornuelle-63867630/"
              target="_blank"
              rel="noreferrer"
              className="Reference-Block Reference-Block-Offline"
            >
              <div className="Reference-Company-Icon Reference-Company-Icon-Offline">
                <img src={DigipenIcon} alt="" />
              </div>
              <div className="Reference-Preview-Name Reference-Preview-Name-Offline">
                Chris Cornuelle
              </div>
              <span>Instructor @ DigiPen</span>
            </a>
            <a
              href="https://www.linkedin.com/in/keneisha-wiggan/"
              target="_blank"
              rel="noreferrer"
              className="Reference-Block Reference-Block-Offline"
            >
              <div className="Reference-Company-Icon Reference-Company-Icon-Offline">
                <img src={MicrosoftIcon} alt="" />
              </div>
              <div className="Reference-Preview-Name Reference-Preview-Name-Offline">
                Keneisha Wiggan
              </div>
              <span>Program Manager @ Microsoft</span>
            </a>
          </div>

          <div className="Right-Col-Badges">
            <span className="Badge-Label">Achievements</span>
            &nbsp;
            <span className="Badge-Count">3</span>
          </div>

          <div className="Achievements-Preview">
            <div className="Achievements-Progress-Text">
              Unlocked 3/4<span>(75%)</span>
            </div>
            <div className="Achievement-Bar">
              <div className="Achievement-Progress"></div>
            </div>
            <div className="Achievements-Block">
              <div className="Achievements-Icon">
                <img src={goldenControllerIcon} alt="" />
              </div>
              <div className="Achievement-Name">Golden Game Controller</div>
              <span className="Achievement-Details">DigiPen & PSSC</span>
            </div>
            <div className="Achievements-Block">
              <div className="Achievements-Icon">
                <img src={trophyIcon} alt="" />
              </div>
              <div className="Achievement-Name">Student of the Quarter</div>
              <span className="Achievement-Details">DigiPen & PSSC</span>
            </div>
            <div className="Achievements-Block">
              <div className="Achievements-Icon">
                <img src={diplomaIcon} alt="" />
              </div>
              <div className="Achievement-Name">Student of the Year</div>
              <span className="Achievement-Details">Digital Media & PSSC</span>
            </div>

            <div className="Achievements-Locked-Spacer">
              Locked Achievements
            </div>

            <div className="Achievements-Block Achievements-Block-Locked">
              <div className="Achievements-Icon">
                <img src={steamIcon} alt="" />
              </div>
              <div className="Achievement-Name">Getting Steamy in here</div>
              <span className="Achievement-Details">Get a job at Valve</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Content;
